export default __webpack_public_path__ + "static/media/yuryu-11.d0568106.svg";